import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import apiClient from './apiClient'; // centralized Axios instance

// Async thunk to fetch all study modes
export const fetchAllStudyModes = createAsyncThunk('studyModes/fetchAllStudyModes', async (_, { rejectWithValue }) => {
    try {
        const response = await apiClient.get('/study-modes');
        return response.data.sort((a, b) => a.ictId_id - b.ictId_id);
    } catch (error) {
        return rejectWithValue(error.response?.data || error.message);
    }
});

// Async thunk to insert a study mode
export const insertStudyMode = createAsyncThunk(
    'studyModes/insertStudyMode',
    async (studyModeData, { rejectWithValue }) => {
        try {
            const response = await apiClient.post('/study-modes', studyModeData);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);

// Async thunk to update study mode status
export const updateStudyModeStatus = createAsyncThunk(
    'studyModes/updateStudyModeStatus',
    async ({ id, status }, { rejectWithValue }) => {
        try {
            const response = await apiClient.patch(`/study-modes/${id}`, { status });
            return { id, status: response.data.status };
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);

const studyModeSlice = createSlice({
    name: 'studyModes',
    initialState: {
        studyModes: [],
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            // Fetch Study Modes
            .addCase(fetchAllStudyModes.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchAllStudyModes.fulfilled, (state, action) => {
                state.loading = false;
                state.studyModes = action.payload;
            })
            .addCase(fetchAllStudyModes.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })

            // Insert Study Mode
            .addCase(insertStudyMode.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(insertStudyMode.fulfilled, (state, action) => {
                state.loading = false;
                state.studyModes.push(action.payload);
            })
            .addCase(insertStudyMode.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })

            // Update Study Mode Status
            .addCase(updateStudyModeStatus.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(updateStudyModeStatus.fulfilled, (state, action) => {
                state.loading = false;
                const { id, status } = action.payload;
                const index = state.studyModes.findIndex((mode) => mode.id === id);
                if (index !== -1) {
                    state.studyModes[index].status = status;
                }
            })
            .addCase(updateStudyModeStatus.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    },
});

export default studyModeSlice.reducer;
